import PropTypes from 'prop-types'
import React from 'react'
import { Link } from 'Blocks'
import { PAGE_CONTEXT as p } from 'Constants'
import { path } from 'Utils'
import config from 'Config'

class ContentLinks extends React.Component {
  static propTypes = {
    articleLinkText: PropTypes.string,
    buttonLocation: PropTypes.string,
    className: PropTypes.any,
    instalookLinkText: PropTypes.string,
    location: PropTypes.shape({
      pathname: PropTypes.any
    }),
    pageName: PropTypes.any,
    setHomeTabMode: PropTypes.func,
    trendLinkText: PropTypes.string,
    useButtons: PropTypes.bool
  }

  componentDidMount() {
    const isHomePage =
      this.props.pageName === p.HOME_ARTICLES ||
      this.props.pageName === p.HOME_ARTICLES ||
      this.props.pageName === p.HOME_ARTICLES

    isHomePage && this.props.setHomeTabMode(p.HOME_ARTICLES)
  }

  render() {
    const {
      className,
      location,
      articleLinkText = 'Articles',
      trendLinkText = 'Trends',
      instalookLinkText = 'Celebrity',
      useButtons = false,
      setHomeTabMode = () => {},
      buttonLocation = ''
    } = this.props
    const articleListPath = config.routes[p.ARTICLE_LIST].path
    const isArticleListPage = location.pathname === articleListPath

    const trendListPath = config.routes[p.TREND_LIST].path
    const isTrendListPage = location.pathname === trendListPath

    const instalookListPath = config.routes[p.INSTALOOK_LIST].path
    const isInstalookListPage = location.pathname === instalookListPath

    const articleClass =
      isArticleListPage || buttonLocation === p.HOME_ARTICLES ? 'current' : ''
    const instalookClass =
      isInstalookListPage || buttonLocation === p.HOME_INSTALOOKS
        ? 'current'
        : ''
    const trendClass =
      isTrendListPage || buttonLocation === p.HOME_TRENDS ? 'current' : ''

    return (
      <ul className={`content-links ${className}`}>
        <li className={`content-links__item ${articleClass}`}>
          {useButtons ? (
            <button
              onClick={() => setHomeTabMode(p.HOME_ARTICLES)}
              className="content-links__link"
            >
              {articleLinkText}
            </button>
          ) : (
            <Link
              to={path(p.ARTICLE_LIST)}
              onClick={() => setHomeTabMode(p.ARTICLE_LIST)}
              className="content-links__link"
            >
              {articleLinkText}
            </Link>
          )}
        </li>
        <li className={`content-links__item ${trendClass}`}>
          {useButtons ? (
            <button
              onClick={() => setHomeTabMode(p.HOME_TRENDS)}
              className="content-links__link"
            >
              {trendLinkText}
            </button>
          ) : (
            <Link
              to={path(p.TREND_LIST)}
              onClick={() => setHomeTabMode(p.TREND_LIST)}
              className="content-links__link"
            >
              {trendLinkText}
            </Link>
          )}
        </li>
        {config.instalooksEnabled && (
          <li className={`content-links__item ${instalookClass}`}>
            {useButtons ? (
              <button
                onClick={() => setHomeTabMode(p.HOME_INSTALOOKS)}
                className="content-links__link"
              >
                {instalookLinkText}
              </button>
            ) : (
              <Link
                to={path(p.INSTALOOK_LIST)}
                onClick={() => setHomeTabMode(p.INSTALOOK_LIST)}
                className="content-links__link"
              >
                {instalookLinkText}
              </Link>
            )}
          </li>
        )}
      </ul>
    )
  }
}

export default ContentLinks
